import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [course, setCourse] = useState('');
  const [message, setMessage] = useState('');
  const [isContactSubmitting, setIsContactSubmitting] = useState(false);
  const [contactSubmitMessage, setContactSubmitMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setSubmitMessage('이메일을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d66o8kpi0m0fka7ok2vg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitMessage('구독이 완료되었습니다!');
        setEmail('');
      } else {
        setSubmitMessage('구독 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      setSubmitMessage('구독 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name || !phone || !course) {
      setContactSubmitMessage('모든 필수 항목을 입력해주세요.');
      return;
    }

    setIsContactSubmitting(true);
    setContactSubmitMessage('');

    try {
      const formData = new URLSearchParams();
      formData.append('name', name);
      formData.append('phone', phone);
      formData.append('course', course);
      formData.append('message', message);

      const response = await fetch('https://readdy.ai/api/form/d66o8kpi0m0fka7ok2vg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setContactSubmitMessage('상담 신청이 완료되었습니다! 빠른 시일 내에 연락드리겠습니다.');
        setName('');
        setPhone('');
        setCourse('');
        setMessage('');
      } else {
        setContactSubmitMessage('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (error) {
      setContactSubmitMessage('신청 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setIsContactSubmitting(false);
    }
  };

  return (
    <footer className="bg-white py-10 md:py-12">
      <div id="contact" className="max-w-6xl mx-auto px-5 md:px-12 mb-10 md:mb-12">
        <div className="bg-gradient-to-br from-[#1a2332] to-[#2a3342] rounded-2xl md:rounded-3xl p-7 md:p-12">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-8 md:mb-8 text-center" style={{ fontFamily: 'Noto Serif KR, serif' }}>
            문의·예약
          </h2>
          
          <form id="contact-form" onSubmit={handleContactSubmit} data-readdy-form className="max-w-2xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mb-5 md:mb-6">
              <div>
                <label className="block text-white text-base md:text-base font-medium mb-2 md:mb-2">
                  이름 <span className="text-[#ff6b6b]">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-5 md:px-5 py-3.5 md:py-3 rounded-lg bg-white/10 border border-white/20 text-white text-base md:text-base placeholder-white/50 focus:outline-none focus:border-[#4ecdc4] transition-colors duration-300"
                  placeholder="이름을 입력하세요"
                  required
                />
              </div>
              <div>
                <label className="block text-white text-base md:text-base font-medium mb-2 md:mb-2">
                  연락처 <span className="text-[#ff6b6b]">*</span>
                </label>
                <input
                  type="tel"
                  name="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full px-5 md:px-5 py-3.5 md:py-3 rounded-lg bg-white/10 border border-white/20 text-white text-base md:text-base placeholder-white/50 focus:outline-none focus:border-[#4ecdc4] transition-colors duration-300"
                  placeholder="010-0000-0000"
                  required
                />
              </div>
            </div>

            <div className="mb-5 md:mb-6">
              <label className="block text-white text-base md:text-base font-medium mb-2 md:mb-2">
                관심 강좌 <span className="text-[#ff6b6b]">*</span>
              </label>
              <select
                name="course"
                value={course}
                onChange={(e) => setCourse(e.target.value)}
                className="w-full px-5 md:px-5 py-3.5 md:py-3 rounded-lg bg-white/10 border border-white/20 text-white text-base md:text-base focus:outline-none focus:border-[#4ecdc4] transition-colors duration-300 cursor-pointer"
                required
              >
                <option value="" className="text-gray-900">강좌를 선택하세요</option>
                <option value="수능 국어 완성반" className="text-gray-900">수능 국어 완성반</option>
                <option value="내신 국어 심화반" className="text-gray-900">내신 국어 심화반</option>
                <option value="중등 국어 기본반" className="text-gray-900">중등 국어 기본반</option>
                <option value="논술 특강반" className="text-gray-900">논술 특강반</option>
              </select>
            </div>

            <div className="mb-5 md:mb-6">
              <label className="block text-white text-base md:text-base font-medium mb-2 md:mb-2">
                문의 내용
              </label>
              <textarea
                name="message"
                value={message}
                onChange={(e) => {
                  if (e.target.value.length <= 500) {
                    setMessage(e.target.value);
                  }
                }}
                maxLength={500}
                rows={4}
                className="w-full px-5 md:px-5 py-3.5 md:py-3 rounded-lg bg-white/10 border border-white/20 text-white text-base md:text-base placeholder-white/50 focus:outline-none focus:border-[#4ecdc4] transition-colors duration-300 resize-none"
                placeholder="궁금하신 내용을 자유롭게 작성해주세요 (최대 500자)"
              ></textarea>
              <div className="text-right text-white/60 text-sm md:text-sm mt-2 md:mt-2">
                {message.length}/500
              </div>
            </div>

            {contactSubmitMessage && (
              <div className={`mb-5 md:mb-5 p-3 md:p-3 rounded-lg text-center text-base md:text-base ${
                contactSubmitMessage.includes('완료') ? 'bg-[#4ecdc4]/20 text-[#4ecdc4]' : 'bg-[#ff6b6b]/20 text-[#ff6b6b]'
              }`}>
                {contactSubmitMessage}
              </div>
            )}

            <button
              type="submit"
              disabled={isContactSubmitting}
              className="w-full py-4 md:py-4 bg-[#ff6b6b] text-white text-base md:text-base rounded-lg font-semibold hover:bg-[#ff5252] transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
            >
              {isContactSubmitting ? '신청 중...' : '상담 신청하기'}
            </button>
          </form>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-5 md:px-12">
        <div className="bg-[#1a2332] rounded-2xl md:rounded-3xl p-7 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mb-10 md:mb-12">
            <div>
              <h3 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-4" style={{ fontFamily: 'Noto Serif KR, serif' }}>
                후니국담 소식
              </h3>
              <p className="text-gray-400 text-base md:text-base mb-8 md:mb-8">
                최신 강좌 정보와 입시 자료를 받아보세요
              </p>

              <form id="newsletter-form" onSubmit={handleNewsletterSubmit} data-readdy-form>
                <div className="mb-4 md:mb-4">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-transparent border-b border-white/30 text-white text-base md:text-base placeholder-white/50 py-3 md:py-3 focus:outline-none focus:border-white transition-colors duration-300"
                    placeholder="이메일 주소"
                    required
                  />
                </div>

                {submitMessage && (
                  <div className={`mb-4 md:mb-4 text-base md:text-base ${
                    submitMessage.includes('완료') ? 'text-[#4ecdc4]' : 'text-[#ff6b6b]'
                  }`}>
                    {submitMessage}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex items-center gap-3 md:gap-3 bg-white text-[#1a2332] px-6 md:px-6 py-3 md:py-3 rounded-full text-base md:text-base hover:bg-gray-100 transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
                >
                  <span className="font-semibold">구독하기</span>
                  <i className="ri-arrow-right-line"></i>
                </button>
              </form>
            </div>

            <div>
              <h4 className="text-white text-base md:text-base font-semibold mb-4 md:mb-4">바로가기</h4>
              <ul className="space-y-3 md:space-y-3">
                <li>
                  <a href="#about" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                    학원 소개
                  </a>
                </li>
                <li>
                  <a href="#courses" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                    강좌 안내
                  </a>
                </li>
                <li>
                  <a href="#teachers" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                    강사진
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                    오시는 길
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white text-base md:text-base font-semibold mb-4 md:mb-4">문의</h4>
              <p className="text-gray-400 text-base md:text-base mb-2 md:mb-2">031-947-2018</p>
              <p className="text-gray-400 text-base md:text-base mb-6 md:mb-6">rlgnsl98@naver.com</p>

              <h4 className="text-white text-base md:text-base font-semibold mb-4 md:mb-4">위치</h4>
              <p className="text-gray-400 text-base md:text-base mb-6 md:mb-6">
                경기도 파주시 청암로17번길 55<br />
                (5층 열린학원)
              </p>

              <h4 className="text-white text-base md:text-base font-semibold mb-4 md:mb-4">사업자 정보</h4>
              <p className="text-gray-400 text-base md:text-base mb-2 md:mb-2">학원 인가 번호: 1423호</p>
              <p className="text-gray-400 text-base md:text-base">사업자 번호: 335-87-00703</p>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 md:pt-8 flex flex-col md:flex-row items-center justify-between gap-5 md:gap-0">
            <div className="flex items-center gap-4 md:gap-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                Instagram
              </a>
              <span className="text-gray-600">·</span>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                Facebook
              </a>
              <span className="text-gray-600">·</span>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                YouTube
              </a>
            </div>

            <p className="text-gray-500 text-sm md:text-base order-last md:order-none">
              © 2025 후니국담. All rights reserved.
            </p>

            <div className="flex items-center gap-4 md:gap-4 flex-wrap justify-center">
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                개인정보처리방침
              </a>
              <span className="text-gray-600">·</span>
              <a href="#" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                이용약관
              </a>
              <span className="text-gray-600">·</span>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-300 text-base md:text-base underline cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
